import { ScheduleTypeAPI } from './types'

export const scheduleTypeApi: ScheduleTypeAPI = ky => {
  return {
    async fetch() {
      return await ky('schedule/type/', {
        method: 'get'
      }).json()
    }
  }
}
